"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contract = void 0;
var utils_1 = require("../../utils");
var contractsEntryContractsUrl = '/contracts/{contractNo}/entry-contracts';
// [Contract]
exports.contract = function (axios) {
    return {
        postContracts: function (request) {
            return axios.post('/contracts', request.data);
        },
        getContractsEntryConfigurations: function (request) {
            return axios.get('/contracts/entry-configurations', request);
        },
        putContractsEntryConfigurations: function (request) {
            return axios.put("/contracts/entry-configurations?mallNo=" + request.params.mallNo, request.data);
        },
        getContractsEntryContracts: function (request) {
            var url = utils_1.paramPathchange('/contracts/{contractNo}/entry-contracts', request);
            return axios.get(url, request);
        },
        postContractsEntryContracts: function (postContractsEntryContracts) {
            var url = contractsEntryContractsUrl;
            url = utils_1.paramPathchange(url, postContractsEntryContracts);
            return axios.post(url, postContractsEntryContracts.data);
        },
        putContractsEntryContracts: function (putContractsEntryContracts) {
            var url = contractsEntryContractsUrl;
            url = utils_1.paramPathchange(url, putContractsEntryContracts);
            return axios.put(url);
        },
        deleteContractsEntryContracts: function (deleteContractsEntryContracts) {
            var url = contractsEntryContractsUrl;
            url = utils_1.paramPathchange(url, deleteContractsEntryContracts);
            return axios.delete(url);
        },
        putContractsInfo: function (_a) {
            var data = _a.data;
            return axios.put('/contracts', data);
        },
        getContractsConfigurations: function (request) {
            return axios.get('/contracts/configurations', request);
        },
        putContractsConfigurations: function (request) {
            return axios.put("/contracts/configurations?mallNo=" + request.params.mallNo, request.data);
        },
        getContractsContractNoRequest: function (request) {
            var url = utils_1.paramPathchange('/contracts/{contractNo}', request);
            return axios.get(url);
        },
        putContractsContractNo: function (request) {
            return axios.put("/contracts/" + request.pathParams.contractNo, request.data);
        },
        deleteContract: function (_a) {
            var contractNo = _a.contractNo;
            return axios.delete("/contracts/" + contractNo);
        },
        putContractsContractNoApprovalRequest: function (request) {
            return axios.put("/contracts/" + request.params.contractNo + "/approval");
        },
        putContractsContractNoDisapprovalRequest: function (request) {
            return axios.put("/contracts/" + request.params.contractNo + "/disapproval");
        },
        putContractsMerchandisers: function (request) {
            return axios.put('/contracts/merchandisers', request.data);
        },
        getContractsMerchandisers: function (request) {
            return axios.get('/contracts/merchandisers', request);
        },
    };
};
